import learnLangOrderData from 'src/config/learnLangOrder.json';
import { LOCALE } from 'src/dataLayer/env';

export const isInvalidLearnLang = (learnLang: string | undefined) : boolean => {
  const typedLearnLangOrderData: {[key: string]: string[]} = learnLangOrderData;
  return !typedLearnLangOrderData[LOCALE].includes(learnLang);
};
